// extracted by mini-css-extract-plugin
export default {"loadMore":"NamkO3KaciSvqIiOEzst","listItem":"CCQCycSpGGE6fOeXBywV","avatar":"u9W5dRpCo5LPQ42ob765","amount":"OLJSGxpa3tfh3Al9Can6"};